import { render, staticRenderFns } from "./exchangeGifts.vue?vue&type=template&id=bb621ba8&scoped=true&"
import script from "./exchangeGifts.vue?vue&type=script&lang=js&"
export * from "./exchangeGifts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb621ba8",
  null
  
)

export default component.exports